import {ItemUnit} from "../../../libs/enum/item-unit.enum";

export class StatisticTopInvoiceArticleDto {

  public articleNumber!: string;
  public articleUnit!: ItemUnit;
  public currencyCode!: string; // Enum: AccCurrency
  public articleCount!: number;
  public sumNetAmount!: number;
  public minNetAmount!: number;
  public maxNetAmount!: number;
  public avgNetAmount!: number;
  public discountCount!: number;
  public discountSumNetAmount: number | undefined;
  public discountMinNetAmount: number | undefined;
  public discountMaxNetAmount: number | undefined;
  public discountAvgNetAmount: number | undefined;

  constructor(init?: Partial<StatisticTopInvoiceArticleDto> | undefined) {
    Object.assign(this, init);
  }
}
